// TODO:
// 1. action icons
// 2. view location block

import React from 'react';
import dateformat from 'dateformat';

import * as S from './BkngDetailsBlock.styles';

const BookingDetailSummaryBlock = ({data}) => {
  const {hotelName, checkin, checkout, statusText} = data;

  const checkinDate = new Date(checkin.replace(/ /g,"T"));
  const checkoutDate = new Date(checkout.replace(/ /g,"T"));

  return(
    <>
      <S.BkngDetailInnerWrap>
        <S.HtlNameStatusWrap>
          <S.BkngHtlNameText>
            {hotelName}
          </S.BkngHtlNameText>
          <S.Status>{statusText}</S.Status>
        </S.HtlNameStatusWrap>
        <S.CheckDateMonthText>
          {dateformat(checkinDate, 'ddd, dd mmm yyyy')} | {dateformat(checkinDate, 'shortTime')} - {dateformat(checkoutDate, 'ddd, dd mmm yyyy')} | {dateformat(checkoutDate, 'shortTime')}
        </S.CheckDateMonthText>
      </S.BkngDetailInnerWrap>
    </>
  );
}

export default  BookingDetailSummaryBlock;